import axios from "axios";

import { encrypt } from "./encrypt";

import { Toast } from "vant";
const store={state:{}}
const api = axios.create({
  baseURL: "http://tzwjw.gaj.taizhou.gov.cn/newadmin/api/",
  timeout: 5000
});
api.interceptors.response.use(
  res => {
    if (res && res.data) {
      switch (res.data.error_code) {
        case 0:
          return res.data;
          // eslint-disable-next-line no-unreachable
          break;
        default:
          Toast.fail(res.data.error_msg);
          return res;
      }
    }
  },
  error => {
    console.log(error);
    if (
      error.code === "ECONNABORTED" &&
      error.message.indexOf("timeout") !== -1
    ) {
      Toast.fail("网络开小差了！");
    }
    return Promise.resolve(error);
  }
);
export default {
  get(url, param) {
    let data = {
      ...param,
      user_token:
        store.state.usertoke || JSON.parse(localStorage.getItem('user_info')).user_token||''
    };
    Toast.loading({
      message: "咨询中...",
      forbidClick: true
    });

    return new Promise((resolve, reject) => {
      api({
        method: "get",
        url,
        params: encrypt(data)
      })
        .then(res => {
          Toast.clear();
          resolve(res.data);
        })
        .catch(err => {
          Toast.fail("系统异常");
          reject(err.res);
        });
    });
  },
  post(url, param, config) {
    Toast.loading({
      message: "咨询中...",
      duration: 0,
      forbidClick: true
    });
    let data = {
      ...param,
      user_token:
        store.state.usertoke || JSON.parse(localStorage.getItem('user_info')).user_token || ''
    };
    return new Promise((resolve, reject) => {
      api({
        method: "post",
        url,
        data: encrypt(data, config),
        config
      })
        .then(res => {
          Toast.clear();
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
          Toast.fail("系统异常");
        });
    });
  }
};
